import { reports } from './reports.js';
import Cookies from 'js-cookie'
import Darkmode from 'darkmode-js'
import tooltipster from 'tooltipster';

jQuery(document).ready(function ($) {
    console.log("[CB] Theme JS loaded.");

    reports.initialise();

    let $body = $("body");

    let classes = {
        container: "cb-container",
        underlay: "cb-underlay",
        overlay: "cb-overlay",
    }

    let addClasses = () => {
        $(".cb-deco:not([data-modified])").each(function () {
            let $this = $(this);
            $this.attr("data-modified", 1);

            let $targetelement;

            if ($this.is(".elementor-column")) {
                $targetelement = $this.find(".elementor-widget-wrap").first();
            } else if ($this.is(".e-con")) {
                $targetelement = $this.find(".e-con-inner").first();

                if (!$targetelement.length) {
                    $targetelement = $this;
                }
            } else if ($this.is(".elementor-element")) {
                $targetelement = $this.find(".elementor-widget-container").first();
            } else if ($this.is(".cb-deco--custom")) {
                $targetelement = $this;
            }

            $targetelement.addClass(classes.container);
            $targetelement
                .prepend(`<div class='${classes.overlay}'></div>`)
                .prepend(`<div class='${classes.underlay}'></div>`);
        });
    }

    addClasses();

    setInterval(() => {
        addClasses();
    }, 1000)

    let backgroundSwiper = ($wrapper) => {
        let mql = window.matchMedia('(min-width: 769px)');
        if (!mql.matches) {
            return;
        }

        console.log("running bg swiper script");

        let $targetElement = $("#tc_custom_swiper_target");

        let swiperInstance = $wrapper.find(".elementor-main-swiper").data('swiper');
        let bgSwiperInstance = $targetElement.find(".elementor-background-slideshow").data('swiper');
        bgSwiperInstance.autoplay.stop();

        let getCurrentSlideForWrapper = ($wrapper) => {
            return $wrapper.find(".swiper-slide-active");
        }

        let changeBgToCurrent = () => {
            let $currentSlide = getCurrentSlideForWrapper($wrapper);
            let $background = $currentSlide.find(".swiper-slide-bg");
            let $bgoverlay = $currentSlide.find(".elementor-background-overlay");

            let bgImage = $background.css("background-image")
            let bgSize = $background.css("background-size")

            let bgOverlayColor;
            if ($bgoverlay.length) {
                bgOverlayColor = $bgoverlay.css("background-color");
            }


            let $targetSlider = $targetElement.find(".elementor-background-slideshow").first();
            let $targetOverlay = $targetElement.find(".elementor-background-overlay").first();


            if (bgOverlayColor) {
                $targetOverlay.css("background-color", bgOverlayColor);
            } else {
                $targetOverlay.css("background-color", "transparent");
            }


            if ($targetSlider.find(".swiper-slide-next").length) {
                // console.log("Sliding next");
                $targetSlider.find(".swiper-slide-next").find("> div")
                    .css("background-image", bgImage)
                    .css("background-size", bgSize)
                    .css("background-repeat", "no-repeat");

                bgSwiperInstance.slideNext();
            } else {
                // console.log("Sliding prev");
                $targetSlider.find(".swiper-slide-prev").find("> div")
                    .css("background-image", bgImage)
                    .css("background-size", bgSize)
                    .css("background-repeat", "no-repeat")

                bgSwiperInstance.slidePrev();
            }
        }

        changeBgToCurrent()

        swiperInstance.on('slideChangeTransitionEnd tcSliderTriggerStart', function (e) {
            changeBgToCurrent();
        });
    }

    let $wrapper = $("#tc_custom_swiper");
    if ($wrapper.length) {
        setTimeout(() => {
            backgroundSwiper($wrapper);
        }, 1000)
    }

    // Accessibility improvements
    // Accessibility improvements
    // Accessibility improvements

    // Negative tabindex for screen readers/keyboard nav
    let $tcAccNoTab = $(".tc-acc__no-tab");
    let tcAccNoTabSelectors = [
        ".elementor-icon-box-icon",
        ".elementor-post__thumbnail__link",
        ".elementor-post__read-more",
    ];

    $.each(tcAccNoTabSelectors, function(index, value) {
        $tcAccNoTab = $tcAccNoTab.add(value);
    })

    $tcAccNoTab.each(function() {
        let $this = $(this);
        let $targetElement = $this;

        if (!$this.is("a")) {
            $targetElement = $this.find("a");
        }

        $targetElement.attr("aria-hidden", true)
        $targetElement.attr("tabindex", -1)
    });

    // Add #content id to main element
    if (!$("#content").length) {
        let selectors = [
            "[data-elementor-type=wp-page]",
            "[data-elementor-type=single-post]",
            "[data-elementor-type=search-results]",
        ];

        $body.find(selectors.join(",")).first().attr("id", "content");
    }

    // Darkmode settings
    // Darkmode settings
    // Darkmode settings

    const darkmode =  new Darkmode({
        saveInCookies: false,
        autoMatchOsTheme: false
    });

    $(".tc__header-contrast-trigger").click(function(e) {
        e.preventDefault();
        darkmode.toggle();
        console.log("Darkmode: " + darkmode.isActivated());
        Cookies.set('darkmode', darkmode.isActivated() ? 1 : 0, { expires: 30, path: '/' });
    })

    if (Cookies.get('darkmode') === "1") {
        console.log("Darkmode: already set in cookie");
        $body.removeClass("darkmode--activated")
        darkmode.toggle();
    } else {
        $body.removeClass("darkmode--activated")
    }

    // Tooltips:
    $('.tc__tooltip, .tc__tooltip a').each(function() {
        if ($(this).is("[title]")) {
            $(this).tooltipster();
        }
    });

});